import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  for: "emerald-toggle",
  class: "inline-flex relative items-center mr-5 cursor-pointer w-max"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-500 peer-focus:ring-4 peer-focus:ring-emerald-300 dark:peer-focus:ring-emerald-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-emerald-500" }, null, -1)
const _hoisted_3 = { class: "ml-3 text-sm font-medium text-gray-900 dark:text-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      value: "",
      id: "emerald-toggle",
      class: "sr-only peer",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputVal) = $event))
    }, null, 512), [
      [_vModelCheckbox, _ctx.inputVal]
    ]),
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.inputVal ? 'Completed' : 'Incomplete'), 1)
  ]))
}